import { Button, Paper, Tooltip, Typography, } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useState } from "react";
import { StyledResponsablesTable } from "../../styled/Responsables";
import { tableConfig } from "../table/tableConfig";

const ResponsablesTable = ({
  data,
  setOpenAddResponsableDialog,
  deleteResponsable,
}) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });

  const handleOpenAdd = () => {
    setOpenAddResponsableDialog(true);
  };

  const columns = [
    {
      accessorKey: "cuit",
      header: "CUIT",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "nombreCompleto",
      header: "Apellido y Nombre",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "cargoEmpresa",
      header: "Cargo",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "nroMatricula",
      header: "Matrícula",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "titulo",
      header: "Título",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "matriculaOtorgadaPor",
      header: "Otorgado Por",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ cell }) => (
        <StyledResponsablesTable.TableCell>
          {cell.getValue()}
        </StyledResponsablesTable.TableCell>
      ),
    },
    {
      accessorKey: "propio",
      header: "Propio",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ row }) => (
        <StyledResponsablesTable.TableCell>
          {row.original.propio ? "Sí" : "No"}
        </StyledResponsablesTable.TableCell>
      ),
    },
  ];

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    enableColumnActions: false,
    enableSorting: false,
    enableRowActions: true,
    renderRowActions: ({ row }) => (
      <Tooltip title="Eliminar" placement="bottom" arrow>
        <StyledResponsablesTable.Icon 
          onClick={() => deleteResponsable(row.original)}
        />
      </Tooltip>
    ),
    data: data || [],
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    renderEmptyRowsFallback: () => (
      <StyledResponsablesTable.MessageContainer>
        <Typography>No hay responsables agregados</Typography>
      </StyledResponsablesTable.MessageContainer>
    ),
    renderTopToolbar: false,
    renderBottomToolbarCustomActions: () => (
      <StyledResponsablesTable.ButtonContainer>
        <Button color="primary" onClick={handleOpenAdd}>
          Agregar
        </Button>
      </StyledResponsablesTable.ButtonContainer>
    ),
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    enableFilters: false,
    enableColumnFilters: false,
  });

  return (
    <Paper>
      <MaterialReactTable table={table} />
    </Paper>
  );
};

export default ResponsablesTable;